<script lang="ts" setup>
  import type { Entry } from 'contentful'
  import { isTypeNavigationItem, isTypeNavigationItemGroup, type TypeHeaderSkeleton } from '@/types/contentful'
  import { definedItems } from '@/utils/contentful'
  import { mdAndUp } from '@/composables/breakpoints'

  defineProps<{
    data: Entry<TypeHeaderSkeleton, 'WITHOUT_UNRESOLVABLE_LINKS', string>
  }>()
</script>

<template>
  <CNavbarBase
    :header-logo-url="data.fields.logo?.fields.file?.url"
    :is-signed-in="null"
    :mobile-menu-nav-links="data.fields.mobileItems"
  >
    <client-only>
      <template v-if="mdAndUp">
        <template v-for="item in definedItems(data.fields.desktopItems)" :key="item.sys.id">
          <CNavDropdown v-if="isTypeNavigationItemGroup(item)" :data="item" />

          <div v-if="isTypeNavigationItem(item)" class="nav-link-wrapper">
            <CLink
              :href="item.fields.href"
              :is-embedded-app-link="item.fields.target === 'App'"
              :target="item.fields.target === 'Tab' ? '_blank' : undefined"
              class="nav-link"
            >
              {{ item.fields.title }}
            </CLink>
          </div>
        </template>
      </template>
    </client-only>
  </CNavbarBase>
</template>

<style lang="scss" scoped>
  .nav-link-wrapper {
    .nav-link {
      color: var(--color-base-black);
      padding: 8px 12px;
    }
  }
</style>
